import { ItemLoader, UpdateContainer, useEntity } from 'components';
import { Enterprise } from 'modules/core/types';
import { ReactElement } from 'react';
import { Logos } from './Logos';
import { XLSXTheme } from './XLSXTheme';
import { Box, Stack } from '@ff-it/ui';
import { BrandingResponse } from './type';

export function Branding(): ReactElement {
  const { endpoint } = useEntity<Enterprise>();

  const url = `${endpoint}branding/`;
  return (
    <ItemLoader<BrandingResponse> url={url}>
      {({ setItem, item, mutate }) => (
        <UpdateContainer
          url={url}
          initialValues={item}
          updateItem={setItem}
          method="POST"
          breadcrumb="Branding"
          mapValues={(values) => {
            const fd = new FormData();
            for (let [key, value] of Object.entries(values)) {
              if (value) {
                if (key === 'xlsx_theme') {
                  value = JSON.stringify(value);
                }
                fd.append(key, value as any);
              }
            }
            return fd;
          }}
        >
          <div className="container px-0 ml-0">
            <Stack direction="horizontal">
              <Box width="1/2">
                <Logos logo_url={item.logo_url} invoice_logo_url={item.invoice_logo_url} mutate={mutate} />
              </Box>
              <Box width="1/2">
                <XLSXTheme />
              </Box>
            </Stack>
          </div>
        </UpdateContainer>
      )}
    </ItemLoader>
  );
}
